import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import Popup from 'Component/Popup';
import SearchField from 'Component/SearchField';
import { SEARCH_POPUP_ID } from 'Component/SearchPopup/SearchPopup.config';

import './SearchPopup.style';

/** @namespace PeggysagePwa/Component/SearchPopup/Component */
export class SearchPopupComponent extends PureComponent {
    static propTypes = {
        payload: PropTypes.shape({
            title: PropTypes.string
        }).isRequired,
        searchCriteria: PropTypes.string.isRequired,
        onSearchBarFocus: PropTypes.func.isRequired,
        onSearchBarChange: PropTypes.func.isRequired,
        onSearchOutsideClick: PropTypes.func.isRequired,
        onClearSearchButtonClick: PropTypes.func.isRequired
        // hideActiveOverlay: PropTypes.func.isRequired
    };

    renderSearchField() {
        const {
            searchCriteria,
            onSearchBarFocus,
            onSearchBarChange,
            onSearchOutsideClick,
            onClearSearchButtonClick
            // hideActiveOverlay
        } = this.props;

        return (
            <SearchField
              key="searchPopup"
              searchCriteria={ searchCriteria }
              onSearchOutsideClick={ onSearchOutsideClick }
              onSearchBarFocus={ onSearchBarFocus }
              onSearchBarChange={ onSearchBarChange }
              onClearSearchButtonClick={ onClearSearchButtonClick }
              isVisible
              isActive={ !!searchCriteria }
              isHideOverlay
              isClickOutsideDisabled
              isFocused
            />
        );
    }

    render() {
        const { payload: { title } } = this.props;

        return (
            <Popup
              id={ SEARCH_POPUP_ID }
              title={ title }
              mix={ { block: 'SearchPopup' } }
            >
                { this.renderSearchField() }
            </Popup>
        );
    }
}

export default SearchPopupComponent;
